export function loadMovies(category, subcategory) {
    switch(category) {
        case "AFI":
            switch(subcategory) {
                case "100 Years 100 Laughs":                    return require("../../data/AFI/100 Years 100 Laughs.json");
                case "100 Years 100 Movies 10th Anniversary":   return require("../../data/AFI/100 Years 100 Movies 10th Anniversary.json");
            }
        case "1910s":
            switch(subcategory) {
                case "1910s":   return require("../../data/1910s/1910s.json");
                case "1910":    return require("../../data/1910s/1910.json");
                case "1911":    return require("../../data/1910s/1911.json");
                case "1912":    return require("../../data/1910s/1912.json");
                case "1913":    return require("../../data/1910s/1913.json");
                case "1914":    return require("../../data/1910s/1914.json");
                case "1915":    return require("../../data/1910s/1915.json");
                case "1916":    return require("../../data/1910s/1916.json");
                case "1917":    return require("../../data/1910s/1917.json");
                case "1918":    return require("../../data/1910s/1918.json");
                case "1919":    return require("../../data/1910s/1919.json");
            }
        case "1920s":
            switch(subcategory) {
                case "1920s":   return require("../../data/1920s/1920s.json");
                case "1920":    return require("../../data/1920s/1920.json");
                case "1921":    return require("../../data/1920s/1921.json");
                case "1922":    return require("../../data/1920s/1922.json");
                case "1923":    return require("../../data/1920s/1923.json");
                case "1924":    return require("../../data/1920s/1924.json");
                case "1925":    return require("../../data/1920s/1925.json");
                case "1926":    return require("../../data/1920s/1926.json");
                case "1927":    return require("../../data/1920s/1927.json");
                case "1928":    return require("../../data/1920s/1928.json");
                case "1929":    return require("../../data/1920s/1929.json");
            }
        case "1930s":
            switch(subcategory) {
                case "1930s":   return require("../../data/1930s/1930s.json");
                case "1930":    return require("../../data/1930s/1930.json");
                case "1931":    return require("../../data/1930s/1931.json");
                case "1932":    return require("../../data/1930s/1932.json");
                case "1933":    return require("../../data/1930s/1933.json");
                case "1934":    return require("../../data/1930s/1934.json");
                case "1935":    return require("../../data/1930s/1935.json");
                case "1936":    return require("../../data/1930s/1936.json");
                case "1937":    return require("../../data/1930s/1937.json");
                case "1938":    return require("../../data/1930s/1938.json");
                case "1939":    return require("../../data/1930s/1939.json");
            }
        case "1940s":
            switch(subcategory) {
                case "1940s":   return require("../../data/1940s/1940s.json");
                case "1940":    return require("../../data/1940s/1940.json");
                case "1941":    return require("../../data/1940s/1941.json");
                case "1942":    return require("../../data/1940s/1942.json");
                case "1943":    return require("../../data/1940s/1943.json");
                case "1944":    return require("../../data/1940s/1944.json");
                case "1945":    return require("../../data/1940s/1945.json");
                case "1946":    return require("../../data/1940s/1946.json");
                case "1947":    return require("../../data/1940s/1947.json");
                case "1948":    return require("../../data/1940s/1948.json");
                case "1949":    return require("../../data/1940s/1949.json");
            }
        case "1950s":
            switch(subcategory) {
                case "1950s":   return require("../../data/1950s/1950s.json");
                case "1950":    return require("../../data/1950s/1950.json");
                case "1951":    return require("../../data/1950s/1951.json");
                case "1952":    return require("../../data/1950s/1952.json");
                case "1953":    return require("../../data/1950s/1953.json");
                case "1954":    return require("../../data/1950s/1954.json");
                case "1955":    return require("../../data/1950s/1955.json");
                case "1956":    return require("../../data/1950s/1956.json");
                case "1957":    return require("../../data/1950s/1957.json");
                case "1958":    return require("../../data/1950s/1958.json");
                case "1959":    return require("../../data/1950s/1959.json");
            }
        case "1960s":
            switch(subcategory) {
                case "1960s":   return require("../../data/1960s/1960s.json");
                case "1960":    return require("../../data/1960s/1960.json");
                case "1961":    return require("../../data/1960s/1961.json");
                case "1962":    return require("../../data/1960s/1962.json");
                case "1963":    return require("../../data/1960s/1963.json");
                case "1964":    return require("../../data/1960s/1964.json");
                case "1965":    return require("../../data/1960s/1965.json");
                case "1966":    return require("../../data/1960s/1966.json");
                case "1967":    return require("../../data/1960s/1967.json");
                case "1968":    return require("../../data/1960s/1968.json");
                case "1969":    return require("../../data/1960s/1969.json");
            }
        case "1970s":
            switch(subcategory) {
                case "1970s":   return require("../../data/1970s/1970s.json");
                case "1970":    return require("../../data/1970s/1970.json");
                case "1971":    return require("../../data/1970s/1971.json");
                case "1972":    return require("../../data/1970s/1972.json");
                case "1973":    return require("../../data/1970s/1973.json");
                case "1974":    return require("../../data/1970s/1974.json");
                case "1975":    return require("../../data/1970s/1975.json");
                case "1976":    return require("../../data/1970s/1976.json");
                case "1977":    return require("../../data/1970s/1977.json");
                case "1978":    return require("../../data/1970s/1978.json");
                case "1979":    return require("../../data/1970s/1979.json");
            }
        case "1980s":
            switch(subcategory) {
                case "1980s":   return require("../../data/1980s/1980s.json");
                case "1980":    return require("../../data/1980s/1980.json");
                case "1981":    return require("../../data/1980s/1981.json");
                case "1982":    return require("../../data/1980s/1982.json");
                case "1983":    return require("../../data/1980s/1983.json");
                case "1984":    return require("../../data/1980s/1984.json");
                case "1985":    return require("../../data/1980s/1985.json");
                case "1986":    return require("../../data/1980s/1986.json");
                case "1987":    return require("../../data/1980s/1987.json");
                case "1988":    return require("../../data/1980s/1988.json");
                case "1989":    return require("../../data/1980s/1989.json");
            }
        case "1990s":
            switch(subcategory) {
                case "1990s":   return require("../../data/1990s/1990s.json");
                case "1990":    return require("../../data/1990s/1990.json");
                case "1991":    return require("../../data/1990s/1991.json");
                case "1992":    return require("../../data/1990s/1992.json");
                case "1993":    return require("../../data/1990s/1993.json");
                case "1994":    return require("../../data/1990s/1994.json");
                case "1995":    return require("../../data/1990s/1995.json");
                case "1996":    return require("../../data/1990s/1996.json");
                case "1997":    return require("../../data/1990s/1997.json");
                case "1998":    return require("../../data/1990s/1998.json");
                case "1999":    return require("../../data/1990s/1999.json");
            }
        case "2000s":
            switch(subcategory) {
                case "2000s":   return require("../../data/2000s/2000s.json");
                case "2000":    return require("../../data/2000s/2000.json");
                case "2001":    return require("../../data/2000s/2001.json");
                case "2002":    return require("../../data/2000s/2002.json");
                case "2003":    return require("../../data/2000s/2003.json");
                case "2004":    return require("../../data/2000s/2004.json");
                case "2005":    return require("../../data/2000s/2005.json");
                case "2006":    return require("../../data/2000s/2006.json");
                case "2007":    return require("../../data/2000s/2007.json");
                case "2008":    return require("../../data/2000s/2008.json");
                case "2009":    return require("../../data/2000s/2009.json");
            }
        case "2010s":
            switch(subcategory) {
                case "2010s":   return require("../../data/2010s/2010s.json");
                case "2010":    return require("../../data/2010s/2010.json");
                case "2011":    return require("../../data/2010s/2011.json");
                case "2012":    return require("../../data/2010s/2012.json");
                case "2013":    return require("../../data/2010s/2013.json");
                case "2014":    return require("../../data/2010s/2014.json");
                case "2015":    return require("../../data/2010s/2015.json");
                case "2016":    return require("../../data/2010s/2016.json");
                case "2017":    return require("../../data/2010s/2017.json");
                case "2018":    return require("../../data/2010s/2018.json");
                case "2019":    return require("../../data/2010s/2019.json");
            }
    }
}